import { favoriteHref } from '@/features/favorites/resolveFavoriteContext';
import { favoriteIcon } from '@/features/favorites/entityIcons';
import { useRecentsStore } from '@/features/recents/useRecentsStore';
import { IconEye } from '@/components/ui/Icon';
import { useHomeNav } from '../useHomeNav';
import { registerWidget, type WidgetRenderProps, type WidgetConfigProps } from '../registry';
import { LIST_ROW } from '../homeStyles';
import { Select } from '@/components/ui/Select';

// How many rows the tile shows; 0 = all tracked recents (the store keeps 50).
const DEFAULT_LIMIT = 10;
const limitOf = (config: Record<string, unknown>) => {
  const n = Number(config?.limit);
  return Number.isFinite(n) && n >= 0 ? n : DEFAULT_LIMIT;
};

function RecentsRender({ config }: WidgetRenderProps) {
  const nav = useHomeNav();
  const recents = useRecentsStore((s) => s.recents);
  const limit = limitOf(config);
  const shown = limit > 0 ? recents.slice(0, limit) : recents;
  if (recents.length === 0) {
    return <div className="text-sm text-muted">Records you open will appear here.</div>;
  }
  return (
    <div className="flex flex-col gap-1">
      {shown.map((r) => (
        <button key={r.id}
          className={`${LIST_ROW} text-left flex items-center gap-2 min-w-0`}
          onClick={() => nav(favoriteHref({ kind: 'record', entity_type: r.entity_type, entity_id: r.entity_id }))}
          title={r.label}>
          <span className="shrink-0 text-muted [&_svg]:w-[13px] [&_svg]:h-[13px]">
            {favoriteIcon({ kind: 'record', entity_type: r.entity_type }, 13)}
          </span>
          <span className="flex-1 min-w-0 truncate">{r.label}</span>
        </button>
      ))}
    </div>
  );
}

function RecentsConfig({ config, onChange }: WidgetConfigProps) {
  const limit = limitOf(config);
  return (
    <div className="grid gap-2">
      <label className="text-[0.75rem] text-muted">Rows shown</label>
      <Select value={String(limit)} onChange={(e) => onChange({ ...(config || {}), limit: Number(e.target.value) })}>
        <option value="5">5</option>
        <option value="10">10</option>
        <option value="15">15</option>
        <option value="20">20</option>
        <option value="0">All</option>
      </Select>
    </div>
  );
}

registerWidget({ type: 'recents', label: 'Recents', defaultSize: 'S', icon: <IconEye size={13} />, accent: '#0d9488', ConfigForm: RecentsConfig, Render: RecentsRender });
